import "./promocodes.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { handleInputNumber } from "../../context/commonFunctions";
import { ProgressDialog } from "../../components/modal";
import {
  Timestamp,
  addDoc,
  collection,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import PromocodesTable from "../../components/promocodesTable/promocodesTable";
import { formatTimestamp } from "../../functions";

const Promocodes = () => {
  const [dataAvailable, setDataAvailable] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [dateValue, setdateValue] = useState(null);
  const [radioTypeValue, setRadioTypeValue] = useState("flat");
  const [promocodeValue, setPromoCodeValue] = useState("");
  const [minimumOrderValue, setMinimumOrderValue] = useState("");
  const [codeFrequency, setCodeFrequency] = useState("");
  const [maxDiscountValue, setMaxDiscountValue] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [promoList, setPromoList] = useState([]);

  const handleClickOpen = () => {
    setPromoCodeValue("");
    setMinimumOrderValue("");
    setMaxDiscountValue("");
    setDiscountValue("");
    setCodeFrequency("")
    setdateValue(null);
    setRadioTypeValue("flat");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  const handlePromoCodeInput = (event) => {
    const { value, selectionStart } = event.target;
    const regex = /^[A-Za-z0-9]+$/;

    if (value === "" || regex.test(value)) {
      setPromoCodeValue(value.toUpperCase());
    } else if (
      event.nativeEvent.inputType === "deleteContentBackward" &&
      selectionStart === 0
    ) {
      setPromoCodeValue("");
    }
  };
  const handleMinimumOrderValue = (event) => {
    const { value } = event.target;
    setMinimumOrderValue(value);
  };
  const handleCodeFrequency = (event) => {
    const { value } = event.target;
    setCodeFrequency(value);
  };
  const handleMaxDiscountValue = (event) => {
    const { value } = event.target;
    setMaxDiscountValue(value);
  };
  const handleDiscountValue = (event) => {
    const { value } = event.target;
    setDiscountValue(value);
  };

  const handleAddPromoButton = async () => {
    if (!promocodeValue.trim()) {
      alert("Oops! Promo code can't be empty.");
    } else if (!minimumOrderValue.trim()) {
      alert("Whoops! Please enter the minimum order value to apply this code.");
    }else if (!codeFrequency.trim()) {
      alert("Whoops! The maximum usage is missing. Please enter it.");
    } else if (!discountValue.trim()) {
      alert("Uh-oh! The discount value is missing. Please enter it.");
    } else if (!maxDiscountValue.trim()) {
      alert("Uh-oh! The maximum discount value is missing. Please enter it.");
    } else if (!dateValue) {
      alert("Hang on! We need a valid date to activate this promo code.");
    } else {
      setOpen(false);
      setLoadingState(true);
      try {
        const newDate = new Date(dateValue); // Create a copy to avoid modifying the original
        newDate.setDate(newDate.getDate() + 1);
        const firestoreTimestamp = Timestamp.fromDate(newDate);
        await addDoc(collection(db, "promoCodes"), {
          active: true,
          code: promocodeValue,
          mov: parseInt(minimumOrderValue),
          discountValue: parseInt(discountValue),
          maxDiscountValue: parseInt(maxDiscountValue),
          frequency: parseInt(codeFrequency),
          type: radioTypeValue,
          validity: firestoreTimestamp,
          timestamp: serverTimestamp(),
        });
        setLoadingState(false);
      } catch (error) {
        setLoadingState(false);
        alert("Failed to add promocode Error- " + error.message);
      }
    }
  };

  useEffect(() => {
    document.title = "Wishallbook >> Promocodes";

    const q = query(collection(db, "promoCodes"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      try {
        console.log(querySnapshot.size);
        if (querySnapshot.size != 0) {
          const promocodes = [];
          querySnapshot.forEach((doc) => {
            const snapshot = doc.data();
            var status = "Active";
            var statusMessage = "Active"
            const currentDateTime = new Date();
            const timestampDate = snapshot.validity.toDate();
            if (timestampDate > currentDateTime) {
              if (snapshot.active === false) {
                status = "Deactive";
                statusMessage = "DeActivated"
              }
            } else {
              status = "Deactive";
              statusMessage = "Expired"
            }

           
           timestampDate.setDate(timestampDate.getDate() - 1);

            // Format the date as "31/01/2024"
            const options = {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            };
            const formattedDateString = timestampDate.toLocaleDateString(
              "en-GB",
              options
            );

            const mapdata = {
              id: doc.id,
              code: snapshot.code,
              type: snapshot.type,
              discount: snapshot.discountValue,
              maxDiscount: snapshot.maxDiscountValue,
              mov: snapshot.mov,
              validity: formattedDateString,
              status: status,
              statusMessage:statusMessage ,
              frequency:snapshot.frequency,
            };
            promocodes.push(mapdata);
          });
          setPromoList(promocodes);
          setDataAvailable(true);
        }
        else
        {
          setDataAvailable(false);
        }
        setInitialLoading(false);
      } catch (error) {
        setInitialLoading(false);
        console.log("Error retrieving banners:", error);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="promocodeParent">
      <Sidebar />
      <div className="promocodeContainer">
        {initialLoading && (
          <div className="intialItem">
            <CircularProgress />
          </div>
        )}
        {!dataAvailable && !initialLoading && (
          <div className="intialItem">
            <Typography>
              No active promotional codes found. Click the "Add Promo Code"
              button to launch your next offer.
            </Typography>
            <Button
              variant="contained"
              sx={{ margin: "20px" }}
              onClick={handleClickOpen}
            >
              Add Promo Code
            </Button>
          </div>
        )}
        {dataAvailable && !initialLoading && (
          <>
            <div className="searchSection">
              {
                //<TextField label="Search promo code..." />
                //<Button sx={{ marginLeft: "20px" }} variant="contained">
                // Search
                //</Button>
              }
              <Button
                variant="contained"
                sx={{ margin: "20px 20px 20px 0px" }}
                onClick={handleClickOpen}
              >
                Add Promo Code
              </Button>
            </div>
            <PromocodesTable rows={promoList} />
          </>
        )}
        <Dialog open={open}>
          <DialogTitle>Add Promo Code</DialogTitle>
          <DialogContent>
            <DialogContentText></DialogContentText>
            <Stack direction={"row"} spacing={2} padding={"10px"}>
              <TextField
                label="Promo Code"
                type="name"
                variant="outlined"
                inputProps={{ maxLength: 50 }}
                value={promocodeValue}
                onChange={handlePromoCodeInput}
              />
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={radioTypeValue}
                onChange={handleRadioType}
              >
                <FormControlLabel
                  value="flat"
                  control={<Radio />}
                  label="Flat"
                />

                <FormControlLabel
                  value="per"
                  control={<Radio />}
                  label="Percentage(%)"
                />
              </RadioGroup>
            </Stack>
            <Stack direction={"row"} spacing={2} padding={"10px"}>
              <TextField
                label="Minimum Order Value"
                value={minimumOrderValue}
                onChange={handleMinimumOrderValue}
                onInput={handleInputNumber}
                inputProps={{ maxLength: 4 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₹</InputAdornment>
                  ),
                }}
                variant="outlined"
              />
              <TextField
                label="Discount Value"
                value={discountValue}
                onChange={handleDiscountValue}
                onInput={handleInputNumber}
                variant="outlined"
              />
            </Stack>
            <Stack direction={"row"} spacing={2} padding={"10px"}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Validity"
                  disablePast
                  value={dateValue}
                  onChange={(newValue) => setdateValue(newValue)}
                />
                <TextField
                  label="Maximum discount"
                  value={maxDiscountValue}
                  onChange={handleMaxDiscountValue}
                  onInput={handleInputNumber}
                  inputProps={{ maxLength: 4 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                  variant="outlined"
                />
              </LocalizationProvider>
            </Stack>
            <Stack direction={"row"} spacing={2} padding={"10px"}>
              <Tooltip title="The total number of times this code can be used by a user.">
              <TextField
                label="Maximum Usage"
                value={codeFrequency}
                onChange={handleCodeFrequency}
                onInput={handleInputNumber}
                inputProps={{ maxLength: 1 }}
                variant="outlined"
              />
              </Tooltip>
            
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleAddPromoButton}>SUBMIT</Button>
          </DialogActions>
        </Dialog>
        <ProgressDialog loading={loadingState} message={"Please wait..."} />
      </div>
    </div>
  );
};

export default Promocodes;
